import { mapState } from 'vuex';
import {
  ApartmentDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'ApartmentItem',
  props: {
    apartment: {
      type: ApartmentDTO,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['edit-apartment'],
})
export default class ApartmentItem extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  apartment!: ApartmentDTO;

  get gates() {
    let apartmentGates: string[] = [];
    this.currentEntrancePlant.gates?.forEach((gate) => {
      if (
        gate.name !== undefined &&
        this.apartment.apartmentId !== undefined &&
        gate.apartments?.includes(this.apartment.apartmentId)
      ) {
        apartmentGates.push(gate.name);
      }
    });

    return apartmentGates;
  }

  editApartment() {
    this.$emit('edit-apartment', this.apartment);
  }
}
